export default __webpack_public_path__ + "static/media/gopay_logo.f686efbd.svg";